import { HeroBanner } from '@unmind/design-system';
import { rem } from 'polished';
import styled from 'styled-components';

export const Banner = styled(HeroBanner)`
  button {
    background: none;
    padding: 0;
    font-size: ${rem(14)};
    font-weight: 500;
    border: none;
    cursor: pointer;
  }

  a,
  button {
    svg {
      position: relative;
      top: ${rem(1)};
      margin-right: ${rem(8)};
    }
  }

  a svg {
    top: ${rem(2)};
  }

  .cta a {
    display: inline-flex;
  }

  @media screen and (min-width: 951px) {
    .cta button {
      width: auto;
    }
  }

  .tag {
    span {
      font-size: inherit;
      font-weight: inherit;
      border-radius: inherit;
    }

    svg {
      width: ${rem(16)};
      height: ${rem(16)};
      margin-right: ${rem(2)};
    }

    svg:last-of-type {
      margin-right: ${rem(8)};
    }
  }
`;
